/**
 * Created by mzhao on 04/8/2022.
 * Description:
 * TileFilterNearby Component
 * ------ maintenance history ------
 */
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { catchError, filter, map, take } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { businessConstants } from '../../../../../constants/business.constants';
import { AppState } from '../../../../../redux';
import { availableEntityTypeSelector } from '../../../../../redux/reducers/entity-type.reducer';
import { relationshipTypeSelector } from '../../../../../redux/reducers/relationship-type.reducer';
import { ALL_VALUE } from '../../../../../tamalelibs/constants/business.constants';
import { EntityType } from '../../../../../tamalelibs/models/entity-type.model';
import { MapFilterContent, MapFilterModel } from '../../../../../tamalelibs/models/map-tile.model';
import { AdhocService } from '../../../../../tamalelibs/services/adhoc.service';
import { MapFilterService } from '../../../../../tamalelibs/services/map-filter.service';
import { FieldActionType, FieldConfig, FieldConfigData, FieldEventType, StandardFilterItemsContact } from '../../../../../widgets/field-selector/field-selector.model';
import { FilterPanelActions, FilterPanelConfig, FilterPanelEvents } from '../../../../../widgets/filter-item/filter-panel/filter-panel.view-model';
import { MultiSelDropdownConfig, MultiSelDropdownFilterConfig } from '../../../../../widgets/multi-sel-dropdown-filter/multi-sel-dropdown-filter.model';
import { ALL_SOURCE_NAME } from '../../../../tam-dashboard/tam-dashboard-map-tile/tam-dashboard-map-nearby/tam-dashboard-map-nearby.component';
import { EMPTY_SOURCE_NAME } from '../../../../work-flow/field/single-entity-dropdown-config.component';
import { RelationshipType } from '../../../../../tamalelibs/models/relationship-type.model';
import { TileFilterConfig, TileFilterEventType } from '../tile-filter.model';
import { StringLiteralsPipe } from '../../../../../pipes/translate.pipe';
import { UtilsService } from '../../../../../tamalelibs/services/utils.service';
import { ArrayHelperService } from '../../../../../tamalelibs/services/array-helper.service';
@Component({
    selector: 'tam-tile-filter-nearby',
    templateUrl: './tile-filter-nearby.component.html',
    styleUrls: ['./tile-filter-nearby.component.scss']
})
export class TileFilterNearbyComponent implements OnInit, OnDestroy {
    @Input() config: TileFilterConfig;
    //#region public properties
    btnText = StringLiteralsPipe.translate('general.add_relationship_filter');

    entityName = ALL_SOURCE_NAME;
    entityTypeConfig: MultiSelDropdownFilterConfig = new MultiSelDropdownFilterConfig(true);
    entityTypeData = [EntityType.CONTACT];
    filterConfig: FilterPanelConfig;
    filterEntityConfig: FilterPanelConfig;
    fieldConfig: FieldConfig;
    fieldEntityConfig: FieldConfig;
    isShowContactFilter = false;
    isShowEntityFilter = false;
    // default value for radius.
    radiusData = [
        { name: 'Within 0.5 miles', value: '0.5' }, { name: 'Within 5 miles', value: '5' }, { name: 'Within 15 miles', value: '15' }, { name: 'Within 30 miles', value: '30' }];
    radiusSelect = this.radiusData[0];
    relationshipDropdownConfig: MultiSelDropdownFilterConfig = new MultiSelDropdownFilterConfig(true);
    relationshipData = [];
    relationshipNames = '';
    sourceName = EMPTY_SOURCE_NAME;
    searchName = '';
    selectedRelationships = [];
    //#endregion

    //#region private properties
    private _allRel = false;
    private _entityData = 'all';
    private _mapfilterModel = new MapFilterModel();
    private _sourceIds = [];
    /**
    * the subscription array that would be unsubscribed on destroying.
    */
    private _destroySubscriptions: Array<Subscription> = [];

    //#endregion

    constructor(
        private _adhocService: AdhocService,
        private _mapFilterService: MapFilterService,
        private _store: Store<AppState>,
        private _utilsService: UtilsService) { }

    //#region public methods

    ngOnInit() {
        this._initEntityTypes();
        this._initRelationshipTypeData();
        this.entityTypeData.forEach(item => {
            this.entityTypeConfig.data.push(MultiSelDropdownConfig.parse(item.id, true, item.name, '', false));
        });

        this.relationshipData.forEach(item => {
            this.relationshipDropdownConfig.data.push(MultiSelDropdownConfig.parse(item.id, false, item.name, '', false));
        });
        this._destroySubscriptions.push(
            this.entityTypeConfig.onChangeValue$.subscribe(data => this.valueChangeSourceEnity(data)),
            this.relationshipDropdownConfig.onChangeValue$.subscribe(data => this.valueChangeSourceRelationship(data)));
        this._isInitFilterPanel();
    }

    ngOnDestroy(): void {
        this._destroySubscriptions.forEach(subscription => subscription.unsubscribe());
        this._destroySubscriptions = [];
    }

    onClickEntity(event) {
        this.entityTypeConfig.open$.next(event.target);
    }

    onClickRelationship(event, val: number = 0) {
        if (this.btnText !== StringLiteralsPipe.translate('general.with_relationship_filter') || val !== 1) {
            this.relationshipDropdownConfig.open$.next(event.target);
        }
    }

    onClickRemoveRelationshipClicked(event) {
        this.relationshipDropdownConfig.data.forEach(item => item.checked = false);
        this._allRel = false;
        this._relationshipChage([]);
    }

    radiusValuChange(value) {
        this._tileFilterChange();
    }

    /**
     * entity adhoc change by entity type change .
     *
     * @param {*} data
     * @memberof TileFilterNearbyComponent
     */
    valueChangeSourceEnity(data): void {
        if (data.length === 0) {
            this.entityName = EMPTY_SOURCE_NAME;
            this._sourceIds = [];
        } else if (data === ALL_SOURCE_NAME.toLowerCase()) {
            this.entityName = ALL_SOURCE_NAME;
            this._sourceIds = this.entityTypeData.map(item => item.id);
        } else {
            this.entityName = data.map(item => item.name).join(',');
            this._sourceIds = data.map(item => item.id);
        }
        this._entityData = data;
        this._hideFilterPanel();
        // according sourceId to load entity field value.
        this._adhocService.getEntityAdhocsByEntityType(this._sourceIds).subscribe(response => {
            const result = this._adhocService.parseResponse(response);
            this.fieldEntityConfig.actions$.next({ type: FieldActionType.changeEntityList, payload: result.title });
        });
        this._tileFilterChange();
    }

    /**
     * get relationship change
     *
     * @param {*} data
     * @memberof TileFilterNearbyComponent
     */
    valueChangeSourceRelationship(data): void {
        let temp: Array<RelationshipType>;
        if (data === ALL_VALUE) {
            this._allRel = true;
            temp = this.relationshipData;
        } else {
            this._allRel = false;
            temp = data;
        }
        this._relationshipChage(temp);
    }

    /**
     * add chbange event for contact entity panel.
     *
     * @private
     * @memberof TileFilterNearbyComponent
     */
    private _fieldConfigSubject() {
        this._destroySubscriptions.push(
            this.fieldConfig.events$.pipe(
                filter(data => data.type === FieldEventType.select)
            ).subscribe((data) => {
                let filtersConfig;
                // contact standard values.
                if (data.payload.type === businessConstants.common.standard) {
                    filtersConfig = this._mapFilterService.getNewFilterDefaultInstance(data.payload.text, data.payload.value);
                }
                this.filterConfig.filtersConfigList.push(filtersConfig);
                this.filterConfig.action$.next({ type: FilterPanelActions.addFilter, payload: [filtersConfig] });
            }),
            this.fieldEntityConfig.events$.pipe(
                filter(data => data.type === FieldEventType.select)
            ).subscribe((data) => {
                let filtersConfig;
                // entity adhoc values.
                filtersConfig = this._mapFilterService.getAdhocFilterDefaultInstance(data.payload);
                this.filterEntityConfig.filtersConfigList.push(filtersConfig);
                this.filterEntityConfig.action$.next({ type: FilterPanelActions.addFilter, payload: [filtersConfig] });
            })
        );
    }



    /**
    * contact/entity filter subscribe
    * action: filter change  or delete.
    * @memberof TamDashboardMapNearbyComponent
    */
    private _filterConfigSubject() {
        this._destroySubscriptions.push(
            this.filterConfig.events$.pipe(
                filter((data) => data.type === FilterPanelEvents.change || data.type === FilterPanelEvents.delete)
            ).subscribe((data) => {
                this.filterConfig.filtersConfigList = [].concat(data.payload);
                this._formatFilterData();
            }),
            this.filterEntityConfig.events$.pipe(
                filter((data) => data.type === FilterPanelEvents.change || data.type === FilterPanelEvents.delete)
            ).subscribe((data) => {
                this.filterEntityConfig.filtersConfigList = [].concat(data.payload);
                this._formFilterEntityAdhocData();
            }),
        );
    }

    /**
    * contact filter format
    * use filters[0] as contact filter
    * @private
    * @memberof TamDashboardMapNearbyComponent
    */
    private _formatFilterData() {
        this._mapfilterModel.filters[0] = new MapFilterContent();
        this._mapfilterModel.filters[0].field = 'contact';
        if (this.filterConfig.filtersConfigList.length > 0) {
            this._mapfilterModel.filters[0] = this._mapFilterService.getFilters(this.filterConfig.filtersConfigList, this._mapfilterModel.filters[0]);
        }
        this._tileFilterChange();
    }

    /**
     *entity filter format
     * use filters[1] as entity filter
     * @private
     * @memberof TamDashboardMapNearbyComponent
     */
    private _formFilterEntityAdhocData() {
        this._mapfilterModel.filters[1] = new MapFilterContent();
        this._mapfilterModel.filters[1].field = businessConstants.common.adhoc;
        if (this.filterEntityConfig.filtersConfigList.length > 0) {
            this._mapfilterModel.filters[1] = this._mapFilterService.getFilters(this.filterEntityConfig.filtersConfigList, this._mapfilterModel.filters[1]);
        }
        this._tileFilterChange();
    }

    /**
     * hide filter panel ,if contact type is unselect.
     * empty filter data.
     * @private
     * @memberof TileFilterNearbyComponent
     */
    private _hideFilterPanel() {
        this.isShowContactFilter = this.entityTypeConfig.data.some(item => item.id === EntityType.CONTACT.id && item.checked);
        this.isShowEntityFilter = this.entityTypeConfig.data.some(item => item.id !== EntityType.CONTACT.id && item.checked);
        if (!this.isShowContactFilter) {
            this.filterConfig.filtersConfigList = [];
            this._formatFilterData();
        }
        if (!this.isShowEntityFilter) {
            this.filterEntityConfig.filtersConfigList = [];
            this._formFilterEntityAdhocData();
        }
    }

    /**
     * Initialize the Contact and Entity filter separately
     * entity use entityAdhoc for set value.
     * @param {*} result
     * @memberof TamDashboardMapNearbyComponent
     */
    private _initFieldSelector(result) {
        // Contact
        this.filterConfig = new FilterPanelConfig();
        this.fieldConfig = new FieldConfig();
        this.fieldConfig.config = new FieldConfigData();
        this.fieldConfig.config.standardItem = StandardFilterItemsContact;
        this.fieldConfig.fieldIndex = 1;

        // Entity
        this.filterEntityConfig = new FilterPanelConfig();
        this.fieldEntityConfig = new FieldConfig();
        this.fieldEntityConfig.config = new FieldConfigData();
        this.fieldEntityConfig.config.standardItem = [];
        this.fieldEntityConfig.config.showSearch = true;
        this.fieldEntityConfig.config.showAdhoc = false;
        this.fieldEntityConfig.config.entityAdhoc = result.title;
        this.fieldEntityConfig.fieldIndex = 2;
    }

    /**
     * init filer panel
     *  1. get adhoc list.
     *  2. init contact entity filter panel.
     *  3. load map filter data from server response.
     *
     * @private
     * @param {*} [ids=[ALL_SOURCE_NAME]]
     * @memberof TileFilterNearbyComponent
     */
    private _isInitFilterPanel(ids = [ALL_SOURCE_NAME]) {
        if (this.entityTypeConfig) {
            this.isShowContactFilter = this.entityTypeConfig.data.some(item => item.id === EntityType.CONTACT.id && item.checked);
            this.isShowEntityFilter = this.entityTypeConfig.data.some(item => item.id !== EntityType.CONTACT.id && item.checked);
            if (ids) {
                this._destroySubscriptions.push(
                    this._adhocService.getEntityAdhocsByEntityType(ids).subscribe(response => {
                        const result = this._adhocService.parseResponse(response);
                        this._initFieldSelector(result);
                        this._fieldConfigSubject();
                        this._filterConfigSubject();
                        this._initMapFilterData();
                    }));
            }
        }
    }

    /**
     * set filter value from tile setting
     *
     * @private
     * @memberof TileFilterNearbyComponent
     */
    private _initMapFilterData() {
        const data = this.config.mapConfig;
        if (data) {
            const filterData = data.filterData;
            // set radius value
            this.radiusSelect = this.radiusData.filter(item => item.value === filterData.radiusSelect)[0];
            // entity Type data ,include  all , '' , Array.
            if (filterData.entityType === ALL_VALUE) {
                this.entityName = ALL_SOURCE_NAME;
            } else if (filterData.entityType === '') {
                this.entityName = EMPTY_SOURCE_NAME;
                this.entityTypeConfig.data.forEach(element => {
                    element.checked = false;
                });
            } else {
                this.entityName = filterData.entityType.map(item => item.name).join(',');
                this.entityTypeConfig.data.forEach(element => {
                    element.checked = false;
                    filterData.entityType.forEach(item => {
                        if (element.id === item.id) {
                            element.checked = true;
                        }
                    });
                });
            }
            // display relationship data in filter dropdown.
            if (filterData.relationships === ALL_VALUE) {
                this.relationshipDropdownConfig.data.forEach(item => {
                    item.checked = true;
                });
            } else if (filterData.relationships === '') {
                this.entityTypeConfig.data.forEach(element => {
                    element.checked = false;
                });
            } else {
                this.relationshipDropdownConfig.data.forEach(element => {
                    element.checked = false;
                    filterData.relationships.forEach(item => {
                        if (element.id === item.id) {
                            element.checked = true;
                        }
                    });
                });
            }
            // set entity type data
            this.valueChangeSourceEnity(filterData.entityType);
            this.filterConfig.filtersConfigList = data.filterList.filterContactConfigList;
            this.filterEntityConfig.filtersConfigList = data.filterList.filterEntityConfigList;
            this._mapfilterModel = filterData.mapFilter;
            this.valueChangeSourceRelationship(filterData.relationships);
        }
        this._tileFilterChange();
    }

    private _initEntityTypes() {
        this._store.pipe(select(availableEntityTypeSelector),
            filter(res => res != null),
            take(1)
        ).subscribe(res => this._takeEntityType(res));
    }

    /**
     * get RealtionshipTypes Data
     *
     * @private
     * @memberof TileFilterNearbyComponent
     */
    private _initRelationshipTypeData() {
        this._destroySubscriptions.push(
            this._store.pipe(select(relationshipTypeSelector))
                .subscribe(items => {
                    if (items && items.length > 0 && typeof items === 'object') {
                        ArrayHelperService.sort(items, 'name');
                        this.relationshipData = items;
                    }
                })
        );
    }

    //#endregion

    //#region private methods
    private _relationshipChage(data: any) {
        this.selectedRelationships = data;
        this.relationshipNames = this._allRel ? ALL_VALUE : this.selectedRelationships.map(item => item.name).join(', ');
        if (!this.relationshipNames) {
            this.btnText = StringLiteralsPipe.translate('general.add_relationship_filter');
        } else {
            this.btnText = StringLiteralsPipe.translate('general.with_relationship_filter');
        }
        this._tileFilterChange();
    }

    /**
     * get entity Types
     *
     * @private
     * @param {*} res
     * @memberof TileFilterNearbyComponent
     */
    private _takeEntityType(res) {
        ArrayHelperService.sort(res, 'name');
        this.entityTypeData = this.entityTypeData.concat(res.slice());
        this._sourceIds = this.entityTypeData.map(item => item.id);
    }
    /**
     * change values when user change some filter control
     *
     * @private
     * @memberof TileFilterNearbyComponent
     */
    private _tileFilterChange() {
        const filterContactConfigList = this.filterConfig ? this.filterConfig.filtersConfigList : [];
        const filterEntityConfigList = this.filterEntityConfig ? this.filterEntityConfig.filtersConfigList : [];
        this.config.events$.next({
            type: TileFilterEventType.mapChange, payload: {
                isMap: true, filterData:
                {
                    radiusSelect: this.radiusSelect.value,
                    entityType: this._entityData, mapFilter: this._mapfilterModel, relationships: this.selectedRelationships
                },
                filterList: { filterContactConfigList: filterContactConfigList, filterEntityConfigList: filterEntityConfigList }
            }
        });
    }
    //#endregion
}
